<ll-titulo>Estadisticas de evolución por planificación.</ll-titulo>

<ng-container *ngIf="route.params | async as params">
    <grafico-evolutivo-clase-seguimiento [idPlanificacion]="idPlanificacion"></grafico-evolutivo-clase-seguimiento>
</ng-container>
